<template lang="html">
  <div>
    <router-link 
      v-for="(routeItem, index) in routesList"
      :to="{name: routeItem.route.name, params: {}}/* this is an ambiguous thing prevents route vacancy id to be cached */"
      :key="index"
    > 
      {{ $tr(routeItem.labelKey) }}
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
  @import "../../../styles/colors.scss";

  a {
    display: block;
    margin: 20px 0;
    font-size: 16px;
  }

  .router-link-active {
    font-weight: bold;
  }
</style>

<script>
  export default {
    name: 'preferences-navigation',

    props: {
      routesList: {
        type: Array,
        default: () => []
      }
    }
  }
</script>
